import React from "react";
import classnames from "classnames";

import "./index.scss";

export interface DividerProps {
  type: "vertical" | "horizontal";
  className?: string;
}

export default function Divider(props: DividerProps) {
  const { type, className } = props;
  return <div className={classnames("divider", className, type)} />;
}
